import React, { Component } from 'react';
import { downloadQuoteSubmission, downloadQuoteRevisionSubmission } from '../api';

import { API_GATEWAY_NAME, API } from '../../../amplify';
import FileViewer from 'react-file-viewer';
import PDFLink from './GenerateLink';
import { Loading } from '../../components/shared';
import { toastify } from '../../components/shared/Toasts';
import ToastMessagesPdf from './ToastMessagesPdf';

class PDFPreview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: {},
            pdfLink: '',
            loading: false
        };
    }

    async componentWillMount() {
        this.fetchQuotepdf();
    }

    fetchQuotepdf = async () => {
        try {
            let data = null;
            if (this.props.revision !== undefined) {
                const response = await downloadQuoteRevisionSubmission(
                    this.props.user,
                    this.props.submissionid,
                    this.props.revision,
                    false
                );
                data = response.data;
            } else {
                const response = await downloadQuoteSubmission(
                    this.props.user,
                    this.props.submissionid,
                    false
                );
                data = response.data;
            }

            this.setState({
                pdfLink: data,
                loading: true
            });
        } catch (error) {
            this.props.onHide();
            this.setState({
                loading: false
            });
            toastify.error(ToastMessagesPdf.failPdf);
        }
    };
    render() {
        return (
            <div>
                {
                    <PDFLink
                        custom_class={this.props.custom_class}
                        pdfLink={this.state.pdfLink}
                        show={this.props.show}
                        onHide={this.props.onHide}
                        loading={this.state.loading}
                    />
                }
            </div>
        );
    }
};

export default PDFPreview;
